import React from 'react'
import './App.css'

import RouteWrapper from './routers/router'

import {useWindowSize} from './utils/hooks'
import CoffeeView from './components/CoffeeView'
import {TABLET_BREAKPOINT} from './utils/style'
import {WorkspaceProvider} from './hooks/useWorkspace'
import {Toaster} from 'ui-v2'

const App: React.FC = () => {
	const {width: screenWidth} = useWindowSize()

	const isTablet = screenWidth <= TABLET_BREAKPOINT

	if (isTablet) {
		return <CoffeeView />
	}

	return (
		<WorkspaceProvider>
			<Toaster className={'z-500000'} />
			<RouteWrapper />
		</WorkspaceProvider>
	)
}

export default App
